import type { ReactNode } from 'react';
import s from './InfoBox.module.scss';

interface InfoBoxProps {
  children: ReactNode;
}

/** Renders a banner with any message content */
function InfoBox({ children }: InfoBoxProps) {
  return <div className={s.bannerWrapper}>{children}</div>;
}

export default InfoBox;
